import React, { useEffect } from "react";
import LoadTable from "../LoadTable/LoadTable";
import { useModalContext } from "../Reactportal/ModalContext";
import PortalFooter from "../Reactportal/PortalFooter";
import Reactportal from "../Reactportal/Reactportal";
import "./SelectDataFromTable.scss";

const SelectDataFromTable = ({ data, selectedRows, TypeOfPortal, toggle, setToggle, TableKey }) => {
  const Form_Key = "Select_Vehicle_data";
  const { pushModal, popModal } = useModalContext();

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  console.log(selectedRows, "selectedRowsselectedRows");

  const Closeformfunction1 = () => {
    setToggle(false);
  };
  const footerContent = (
    <PortalFooter
      submitType={""}
      handleformclose={Closeformfunction1}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
    />
  );
  return (
    <>
      {
        <div>
          <Reactportal
            open={toggle}
            onClose={Closeformfunction1}
            FoooterContent={footerContent}
            TypeOfPortal={"Select"}
          >
            <div className="selected-container">
              {!data?.length ? (
                <p>Data not Avaliable</p>
              ) : (
                <LoadTable
                  title={`Select_Table_Data_${TableKey}`}
                  data={data}
                  selectedRows={selectedRows[0] ? selectedRows : []}
                />
              )}
            </div>
          </Reactportal>
        </div>
      }
    </>
  );
};

export default React.memo(SelectDataFromTable);
